"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "bucine": {
    "aeacc51d": [{
      "hkey": "8be6dfda",
      "slug": "bucine",
      "name": "Bucine",
      "primary": true,
      "skipSearch": false
    }],
    "centro": [{
      "hkey": "8be6dfda",
      "slug": "bucine",
      "name": "Bucine",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "b004c311": [{
      "hkey": "d1f6c575",
      "slug": "bucine",
      "name": "Bucine",
      "primary": true,
      "skipSearch": false
    }],
    "mercatale": [{
      "hkey": "d1f6c575",
      "slug": "bucine",
      "name": "Bucine",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;